var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { runtime } from '../../../classes/runtime/Runtime';
import { AvailableTooltip } from '../../../components/other/AvailableTooltip';
let CycleBarCountdownButton = class CycleBarCountdownButton extends React.PureComponent {
    get emptyNextButton() {
        return (React.createElement("div", { style: {
                width: 45,
                height: 45
            } }));
    }
    get nextButton() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(AvailableTooltip, { title: "Pause", placement: "right" },
                React.createElement("div", { style: {
                        cursor: 'pointer',
                        height: 45,
                        width: 45,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } },
                    React.createElement("i", { className: "fas fa-pause", onClick: () => (app.appClock.isAppClockPaused = true), style: { fontSize: 20 } })))));
    }
    get pausedButton() {
        return (React.createElement(AvailableTooltip, { title: "Weiter zur n\u00E4chsten Frage", placement: "top" },
            React.createElement("div", { onClick: () => (this.props.app.appClock.isAppClockPaused = false), style: {
                    cursor: 'pointer',
                    height: 45,
                    width: 45,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement("i", { className: "fas fa-play", style: { fontSize: 20 } }))));
    }
    render() {
        const { app } = this.props;
        if (runtime.solidBrowserRuntime.browserDevice.isSmartphone)
            return null;
        if (app.appClock.isAppClockPaused) {
            return this.pausedButton;
        }
        if (!app.question)
            return this.emptyNextButton;
        if (app.question.answeringState.currentAnswerState !== QuestionAnswerState.Feedback)
            return this.emptyNextButton;
        if (app.question.answeringFeedback.isFeedbackTimeNearlyOver)
            return this.emptyNextButton;
        return this.nextButton;
    }
};
CycleBarCountdownButton = __decorate([
    observer
], CycleBarCountdownButton);
export { CycleBarCountdownButton };
